// =========================================================
// Vojjin COLLECT Utilities
// =========================================================

;(function (global) {
    // Create namespace
    const G = global.gemini || (global.gemini = {});
    G.collect = {};

    function idOrName(el, formElement) {
        return gemini.dom.attr(el, "id", formElement) || gemini.dom.attr(el, "name", formElement);
    }

    /**
     * Retrieves a string value associated with a specific key from the collection.
     *
     * @function
     * @name G.collect.getString
     * @param {string} element - The key used to identify DOM element and retrieve the string value.
     * @returns {string|null|undefined} The string value associated with the given element, or a fallback if the element is not found.
     */
    G.collect.getString = function (element) {
        let el = gemini.dom.get(element, 0);
        if (el !== null) {
            let val = el.value, ret = "";
            try {
                return val.toString().trim();
            } catch (e) {
                return "";
            }
        } else {
            return "";
        }
    }

    /**
     * Retrieves an integer value based on the specified parameters or logic.
     *
     * The `getInt` method in the `collect` namespace of the `G` object is intended
     * to return a numeric value that represents an integer. The exact behavior,
     * parameters, and return value depend on the implementation details of this method.
     *
     * @function getInt
     * @memberof G.collect
     * @returns {number} An integer value determined by the method's logic.
     */
    G.collect.getInt = function (element) {
        let val = G.collect.getString(element);
        if (!isNaN(parseInt(val))) {
            return parseInt(val);
        } else {
            return 0;
        }
    }

    /**
     * Retrieves a floating-point number value from an object or collection.
     *
     * This method is used to extract and return a numerical value that is a float
     * from a specified collection, performing any necessary operations or checks
     * to ensure the value meets expected requirements.
     *
     * It is the caller's responsibility to verify that the value retrieved
     * aligns with the desired precision and is appropriately handled based on its usage.
     */
    G.collect.getFloat = function (element) {
        let val = G.collect.getString(element);
        if (!isNaN(parseFloat(val))) {
            return parseFloat(val);
        } else {
            return 0;
        }
    }

    G.collect.getChecked = function (element) {
        let el = gemini.dom.get(element, 0);
        if (el && el.type === "checkbox") {
            return !!el.checked;
        } else {
            return false;
        }
    }

    G.collect.getFormValues = function (formSelector) {
        let formElement = gemini.dom.get(formSelector, 0);
        if (formElement === null) return [];

        let savedata = {};

        gemini.dom.each("input[type=hidden]", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("textarea", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("input[type=text]", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("input[type=email]", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("input[type=password]", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("input[type=checkbox]", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getChecked(el) ? 1 : 0;
        }, formElement)
        gemini.dom.each("select", function (el) {
            savedata[idOrName(el, formElement)] = G.collect.getString(el);
        }, formElement)
        gemini.dom.each("input[type=radio]", function (el) {
            const name = idOrName(el, formElement);
            if (!name) return;
            if (savedata[name] !== undefined) return;
            const checked = formElement.querySelector(`input[type=radio][name="${name}"]:checked`);
            savedata[name] = checked ? G.collect.getString(checked) : "";
        }, formElement);
        return savedata;
    }

    if (typeof module !== "undefined" && module.exports) {
        module.exports = G.collect;
    } else {
        global.gemini = G;
        global.gemini.collect = G.collect;

    }
})(typeof globalThis !== "undefined" ? globalThis : this);
